import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { ApiService } from '../services/api.service';

export const homeRedirectGuard: CanActivateFn = (): Observable<UrlTree> => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  const api    = inject(ApiService);

  // Standard user — always go to their own account dashboard
  if (!auth.isAdmin) {
    const accountId = auth.currentUser()?.account_id;
    return of(router.createUrlTree(accountId ? ['/accounts', accountId] : ['/projects']));
  }

  // Admin — go to the dashboard directly if exactly 1 active account exists,
  // otherwise go to the accounts list
  return api.get<{ id: number; name: string }[]>('/api/accounts').pipe(
    map(accounts =>
      accounts.length === 1
        ? router.createUrlTree(['/accounts', accounts[0].id])
        : router.createUrlTree(['/accounts']),
    ),
  );
};
